import { Component, HostBinding, inject, input, signal } from '@angular/core';
import { GeneralService } from '@shared/services/general.service';
import { Subscription, interval } from 'rxjs';

@Component({
  selector: 'app-countdown-release',
  templateUrl: './countdown-release.component.html',
  styleUrl: './countdown-release.component.scss',
})
export class CountdownReleaseComponent {
  @HostBinding('class.is-in-promotion') public isInPromotionHostBinding!: boolean;
  ReleaseDate = input.required<Date>();
  IsInPromotion = input<boolean>(false);
  minutes = signal<number | undefined>(undefined);
  hours = signal<number | undefined>(undefined);
  days = signal<number | undefined>(undefined);
  private countdown$?: Subscription;

  private generalService = inject(GeneralService);

  handleTime() {
    const nowDate = new Date().getTime();
    const rDate = new Date(this.ReleaseDate()).getTime();
    if (rDate > nowDate) {
      const diff = Math.abs(rDate - nowDate) / 1000;
      this.minutes.set(Math.floor(diff / 60) % 60);
      this.hours.set(Math.floor(diff / 3600) % 24);
      this.days.set(Math.floor(diff / 86400));
    } else {
      this.minutes.set(0);
      this.hours.set(0);
      this.days.set(0);
    }
  }

  ngOnInit() {
    this.isInPromotionHostBinding = this.IsInPromotion();
    if (this.generalService.isBrowserOnly) {
      this.handleTime();
      this.countdown$ = interval(60000).subscribe(() => {
        this.handleTime();
      });
    }
  }

  ngOnDestroy() {
    this.countdown$?.unsubscribe();
  }
}
